
import { debounce } from '@/utils'
import { mapGetters } from 'vuex'
const giveUpBargainComp = () => import('@/components/Bargain/buyer/component/giveUpBargain')
const agreeBargainComp = () => import('@/components/Bargain/buyer/component/agreeBargain')
const refuseBargainComp = () => import('@/components/Bargain/buyer/component/refuseBargain')
const againBargain = () => import('@/components/Bargain/buyer/component/againBargain')
import { bargainStatus } from '@/enum/localEnum'
export default {
	data() {
		return {
			buttonList: []
		}
	},
	props: {
		item: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		...mapGetters({
			/**
			 * 公共剩余砍价次数
			 */
			bargainCountConfig: 'bargain/bargainCountConfig'
		})
	},
	watch: {
		item: {
			handler(newItem) {
				if (newItem?.id || newItem?.bargainId) {
					this.getBargainStatusList()
				}
			},
			deep: true
		}
	},
	methods: {
		/**
		 * 重置
		 */
		onReset() {
			this.buttonList = []
			this.$emit('onGetTagStatus', [])
		},
		/**
		 * 获取砍价状态标签、按钮展示
		 */
		getBargainStatusList() {
			this.onReset()
			let statusList = []
			let buttonList = []
			const { status, substatus, statusName, subStatusName, buyerPrice, sellerPrice, priceCount, bargainOrderPayStatus, subBargainOrderPayStatus, goodsRemainderCount } = this.item
			const remainderCount = this.bargainCountConfig?.remainderCount || 0
			switch (status) {
				// 处理砍价进行中的状态
				case 'IN_PROGRESS':
					// 买家报价
					if ([1, 3].includes(priceCount)) {
						statusList.push({ name: `<span class="yellow-bg">我的报价 <span class="red">￥${buyerPrice}</span></span>` })
					}
					// 卖家还价
					if ([2, 4].includes(priceCount)) {
						statusList.push({ name: `<span class="yellow-bg">卖家还价 <span class="red">￥${sellerPrice}</span></span>` })
					}
					switch (substatus) {
						// 买家报价中，等待卖家响应
						case 'WAITING_FOR_SELLER_RESPONSE':
							statusList.push({ name: `砍价中-待<span class="green">卖家</span>响应` })
							buttonList.push({ name: '放弃砍价', plain: true, handler: () => this.onGiveUpBargain() })
							break
						// 卖家还价中，等待买家响应
						case 'WAITING_FOR_BUYER_RESPONSE':
							statusList.push({ name: `砍价中-待<span class="blue">买家</span>响应` })
							buttonList.push({ name: '拒绝', plain: true, handler: () => this.onRefuseBargain() })
							if (Number(priceCount) === 2) {
								// 如果报价次数等于2，则显示再次报价按钮
								buttonList.push({ name: '再次报价', plain: true, handler: () => this.onAgainBargain() })
							}
							buttonList.push({ name: '同意还价', handler: () => this.onAgreeBargain() })
							break
					}
					break
				// 处理砍价成功的状态
				case 'SUCCESS':
					switch (bargainOrderPayStatus) {
						// 待支付
						case 'NOT_PAID':
							// 显示立即购买按钮
							buttonList.push({ name: '立即购买', handler: () => this.onBuy(this.item) })
							break
						// 已支付
						case 'PAID':
							// 显示联系客服和查看订单按钮
							buttonList.push({ name: '查看订单', plain: true, handler: () => this.onViewOrderDetails() })
							buttonList.push({ name: '联系客服', handler: () => this.onContactService() })
							break
						// 处理砍价被取消的情况
						case 'CANCELLED':
							// 显示浏览其他商品按钮
							buttonList.push({ name: '浏览其他商品', plain: true, handler: () => this.onViewOtherGoods() })
							// 如果是买家超时、买家取消或平台超时，则显示重新砍价按钮，并且砍价次数大于0
							if (['BUYER_TIMEOUT', 'BUYER_CANCELLED', 'PLATFORM_TIMEOUT'].includes(subBargainOrderPayStatus) && goodsRemainderCount > 0 && remainderCount > 0) {
								buttonList.push({ name: '重新砍价', handler: () => this.onResetBargain() })
							}
							break
					}
					// 买家报价
					if ([1, 3].includes(priceCount)) {
						statusList.push({ name: `我的报价 <span class="red">￥${buyerPrice}</span>` })
					}
					// 卖家还价
					if ([2, 4].includes(priceCount)) {
						statusList.push({ name: `卖家还价 <span class="red">￥${sellerPrice}</span>` })
					}
					statusList.push({ name: `${statusName}-${subStatusName === '砍价自动同意' ? '卖家已同意' : subStatusName}` })
					break
				// 处理砍价失败的状态
				case 'CANCEL':
				case 'FAILED':
					// 显示浏览其他商品按钮
					buttonList.push({ name: '浏览其他商品', plain: true, handler: () => this.onViewOtherGoods() })
					// 如果是价格更高、买家拒绝、买家取消、卖家拒绝、卖家取消或超时取消，则显示重新砍价按钮
					switch (substatus) {
						case 'HIGHER_PRICE_OFFER':
						case 'BUYER_REJECTED':
						case 'BUYER_CANCEL':
						case 'SELLER_REJECTED':
						case 'SELLER_CANCEL':
						case 'BUYER_RESPONSE_TIMEOUT_CANCEL':
						case 'SELLER_RESPONSE_TIMEOUT_CANCEL':
							if (goodsRemainderCount > 0 && remainderCount > 0) buttonList.push({ name: '重新砍价', handler: () => this.onResetBargain() })
							break
					}
					// 买家报价
					if ([1, 3].includes(priceCount)) {
						statusList.push({ name: `我的报价 <span class="red">￥${buyerPrice}</span>` })
					}
					// 卖家还价
					if ([2, 4].includes(priceCount)) {
						statusList.push({ name: `卖家还价 <span class="red">￥${sellerPrice}</span>` })
					}
					statusList.push({ name: `${statusName}-${subStatusName === '砍价自动同意' ? '卖家已同意' : subStatusName}` })
					break
			}
			if (['ITEM_REMOVED', 'ITEM_SOLD'].includes(substatus)) {
				buttonList = []
				buttonList.push({ name: '浏览其他商品', plain: true, handler: () => this.onViewOtherGoods() })
			}

			this.buttonList = buttonList
			this.$emit('onGetTagStatus', statusList)
		},
		/**
		 * 按钮集合
		 */
		onClickButton: debounce(async function (eventHandler) {
			await eventHandler()
		}),
		/**
		 * 放弃砍价
		 */
		async onGiveUpBargain() {
			const model = this.$pzDialog(
				{
					width: '450px',
					title: '放弃砍价',
					cancelButtonText: '确认放弃',
					confirmButtonText: '再考虑一下',
					customClass: 'bargain-dialog',
					component: giveUpBargainComp,
					onConfirm: () => {
						model.remove()
					},
					onCancel: async () => {
						const par = {
							action: {
								id: this.item.id || this.item.bargainId
							}
						}
						const res = await this.$api.bargainBuyerCancel(par)
						if (!res.success) {
							this.$message.error(res.info)
							model.remove()
							this.$emit('onReload')
							return
						}
						this.$message.success(res.info)
						model.remove()
						this.$emit('onReload')
					}
				},
				this
			)
		},
		/**
		 * 同意还价
		 */
		async onAgreeBargain() {
			const model = this.$pzDialog(
				{
					title: '同意还价',
					width: '450px',
					cancelButtonText: '再考虑一下',
					confirmButtonText: '同意还价',
					component: agreeBargainComp,
					customClass: 'bargain-dialog',
					onConfirm: async () => {
						const par = {
							action: {
								id: this.item.id || this.item.bargainId
							}
						}
						const res = await this.$api.bargainBuyerAgree(par)
						if (!res.success) {
							this.$message.error(res.info)
							model.remove()
							this.$emit('onReload')
							return
						}
						model.remove()
						// this.$emit('onReload')
						// 同意之后触发立即购买逻辑
						this.getBargainBuyerDetail(this.item)
					},
					onCancel: () => {
						model.remove()
					}
				},
				this
			)
		},
		/**
		 * 砍价详情
		 */
		async getBargainBuyerDetail(item) {
			try {
				const par = {
					action: {
						bargainOrderNo: item.bargainOrderNo
					}
				}
				const res = await this.$api.bargainBuyerDetail(par)
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				const data = {
					...res.data,
					disablePoint: true
				}
				this.onBuy(data)
			} catch (err) {}
		},
		/**
		 * 再次报价
		 */
		onAgainBargain() {
			const model = this.$pzDialog(
				{
					title: '再次报价',
					width: '450px',
					showFooter: false,
					component: againBargain,
					customClass: 'bargain-dialog',
					onConfirm: () => {
						model.remove()
						this.$emit('onReload')
					},
					onCancel: () => {
						model.remove()
					}
				},
				this
			)
		},
		/**
		 * 拒绝
		 */
		onRefuseBargain() {
			const model = this.$pzDialog(
				{
					title: '拒绝还价',
					cancelButtonText: '拒绝还价',
					confirmButtonText: '再考虑一下',
					width: '450px',
					component: refuseBargainComp,
					customClass: 'bargain-dialog',
					onConfirm: () => {
						model.remove()
					},
					onCancel: async () => {
						const par = {
							action: {
								id: this.item.id || this.item.bargainId
							}
						}
						const res = await this.$api.bargainBuyerRefuse(par)
						if (!res.success) {
							this.$message.error(res.info)
							model.remove()
							this.$emit('onReload')
							return
						}
						model.remove()
						this.$emit('onReload')
					}
				},
				this
			)
		},
		/**
		 * 查看砍价详情
		 */
		onViewBargainDetails() {
			this.$router.push(`/account/bargainMe/details?bargainOrderNo=${this.item.bargainOrderNo}`)
		},
		/**
		 * 立即购买
		 * 前往砍价订单确认页
		 */
		async onBuy(item) {
			//埋点 砍价卡片立即购买按钮
			!item?.disablePoint && this.$store.dispatch('tracking/PointList', { event: 'BARGAIN_CARD_BUY' })
			// const res = await this.$api.getCheckGoodsStatus({ goodsNo: this.item.goodsNo })
			// if (!res.success) {
			// 	return this.$message.error(res.info)
			// }
			// if (res.data) {
			// 	// 413砍价线下单直接跳转客服聊天
			// 	if (!item.imUserId) return this.$message.error('暂无客服值班')
			// 	this.$store.dispatch('ry/join', { targetId: item.imUserId, conversationType: 1 })
			// 	return
			// }

			/**
			 * 如果生成订单就跳转到订单详情页
			 */

			/**
			 * 线下
			 */
			if (Number(item.bargainOrderType) === bargainStatus.MY_BARGAIN_ENUM.OffLine) {
				if (!item.imUserId) return this.$message.error('暂无客服')
				// await this.onContactService(false)
				// 413砍价线下单直接跳转客服聊天
				this.$store.dispatch('ry/join', { targetId: item.imUserId, conversationType: 1 })
				return
			}
			/**
			 * 线上
			 */
			if (item.orderNo) {
				this.$router.push(`/account/buyerDetails?orderNo=${item.orderNo}`)
				return
			}
			// 没有生成订单则跳转到砍价的订单确认页
			this.$router.push(`/confirmOrder/onlinePay?goodsNo=${item.goodsNo}`)
			// 为啥要用 sessionStorage 来传数据！！！
			const order = {
				...item,
				bargainPrice: item.transactionPrice
			}
			sessionStorage.setItem('orderDtl', JSON.stringify(order))
		},
		/**
		 * 联系客服
		 * imGroup 是否群聊
		 */
		async onContactService(imGroup = true) {
			if (imGroup) {
				try {
					const par = {
						action: {
							bargainId: this.item.id || this.item.bargainId
						}
					}
					const res = await this.$api.getBargainLinkCustomer(par)
					if (!res.success) return this.$message.error(res.info)
					const { linkGroup } = res.data
					// 唤起IM群聊
					this.$store.dispatch('ry/join', { targetId: linkGroup, conversationType: 3 })
				} catch (err) {
					this.$message.error(err.message)
				}
			} else {
				const goodsInformation = {
					goodsNo: this.item.goodsNo,
					price: this.item.goodsPrice,
					url: `${process.env.CANONICAL_URL}/goodsDetails/${this.item.goodsNo}`,
					goodsImg: this.item.goodsImg,
					title: this.item.title
				}

				this.$store.dispatch('ry/sendGoodsMsg', {
					targetId: this.item.imUserId,
					content: goodsInformation
				})
			}
		},
		/**
		 * 查看订单
		 * 前往订单详情页
		 */
		onViewOrderDetails() {
			if (!this.item.orderNo) {
				this.$message.error('订单编号缺失')
				return
			}
			this.$router.push(`/account/buyerDetails?orderNo=${this.item.orderNo}`)
		},
		/**
		 * 重新砍价
		 * 前往商品详情页
		 */
		onResetBargain() {
			this.$router.push(`/goodsDetails/${this.item.goodsNo}`)
		},
		/**
		 * 浏览其他商品
		 * 前往当前游戏列表
		 */
		onViewOtherGoods() {
			this.$router.push(`/goodsList/${this.item.gameId}`)
		}
	},
	created() {
		this.getBargainStatusList()
	}
}
